import { PointOptionsObject } from "highcharts";
import Fund from "../fund";
import FundAllocation from "../fundAllocation";

export default class FundSplitInfo {
    public valueOfPensionPots: number;
    public matchedYears: number;
    public yearsToRetirement: number;
    public isPresentTime: boolean;
    public matchedYearsInWindow: number;
    public drawdowns: Array<PointOptionsObject>;
    public allocations: Array<FundAllocation>;
    public isTakingTaxFreeLumpSum: boolean;
    public taxFreeLumpSumAllocFund: Fund;
    public taxFreeLumpSumAmount: number;

    constructor(valueOfPensionPots: number, matchedYears: number, yearsToRetirement: number, isPresentTime: boolean, matchedYearsInWindow: number, 
        drawdowns: Array<PointOptionsObject>, allocations: Array<FundAllocation>) {
        this.valueOfPensionPots = valueOfPensionPots;
        this.matchedYears = matchedYears;
        this.yearsToRetirement = yearsToRetirement;
        this.isPresentTime = isPresentTime;
        this.matchedYearsInWindow = matchedYearsInWindow;
        this.drawdowns = drawdowns;
        this.allocations = allocations;
    }

    hasMatchedYears(): boolean {
        return this.matchedYears > 0;
    }

    allYearsAreMatched(): boolean {
        return this.matchedYears == this.matchedYearsInWindow;
    }
}
